﻿(() => {
  if (window.hadouraProductDetailReady) return;
  window.hadouraProductDetailReady = true;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-gallery-thumb], [data-quantity-change]');
    const section = button?.closest('[data-product-detail]');
    if (!section) return;
    if (button.hasAttribute('data-gallery-thumb')) {
      const main = section.querySelector('[data-gallery-main]');
      if (!main || !button.dataset.fullSrc) return;
      main.removeAttribute('srcset');
      main.src = button.dataset.fullSrc;
      main.alt = button.dataset.fullAlt || 'Product image';
      section.querySelectorAll('[data-gallery-thumb]').forEach(item => {
        item.classList.toggle('is-current', item === button);
        item.setAttribute('aria-pressed', String(item === button));
      });
      return;
    }
    const quantity = section.querySelector('[name="quantity"]');
    if (!quantity) return;
    const minimum = Number(quantity.min) || 1;
    const step = Number(quantity.step) || 1;
    const maximum = quantity.max ? Number(quantity.max) : Infinity;
    const current = Number(quantity.value) || minimum;
    quantity.value = String(Math.min(maximum, Math.max(minimum, current + Number(button.dataset.quantityChange) * step)));
    quantity.dispatchEvent(new Event('change', {bubbles:true}));
  });
})();
